var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"chevron-down"},React.createElement("path",{"id":"Icon","d":"M8.26196 12.2024L16.1905 20.1309L24.1191 12.2024","stroke":"#3C5DFF","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round"})));
}

ChevronDown.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
